import { Injectable } from "@angular/core";
import { DatesHelpers } from "../helpers/date";
@Injectable({
  providedIn: "root",
})
export class FormateService {
  constructor(private datesHelpers: DatesHelpers) {}

  formatDateToTextual(isoDateString: string): string {
    const date = this.datesHelpers.formatDateToTextual2(isoDateString);
    return date;
  }

  getDemandeFormat(demand: any) {
    return {
      date: this.formatDateToTextual(demand?.created_at),
      reference: demand?.reference,
      id: demand?.id,
      domaine_id: demand?.domaine_id,
      demande_type: demand?.domaine_id === 1 ? "transporter" : "service",
      delivery_type: demand?.delivery_type,
      distance: demand?.distance,
      delivery_date: demand?.delivery_date,
      phone_number: demand?.phone_number,
      point_of_arrival: demand?.point_of_arrival,
      point_of_arrival_lat: demand?.point_of_arrival_lat,
      point_of_arrival_long: demand?.point_of_arrival_long,
      starting_point: demand?.starting_point,
      starting_point_lat: demand?.starting_point_lat,
      starting_point_long: demand?.starting_point_long,
      points_distance: demand?.points_distance,
      remarks: demand?.remarks ?? "",
      tarif_service: demand?.tarif_service,
      total_paye: demand?.total_paye,
      type_bagage: demand?.type_bagage,
      statut: demand?.statut,
      images_after: demand?.imagePreuveAfter,
      description: demand?.description,
      audio: demand?.audio,
      audio_duration: demand?.duration,
      devis: demand?.devis ? demand.devis : null,
      job:
        demand.point_of_arrival_lat && demand.point_of_arrival_long
          ? "Transporteur"
          : demand?.domaine?.nom,
      images: demand?.images,
      imagePreuveAfter: demand?.imagePreuveAfter,
      imagePreuveBefore: demand?.imagePreuveBefore,
      meetings: demand?.meetings,
      attent: demand?.attent || "PENDING",
      start_position_attent: demand?.start_position_attent || "PENDING",
      prestataire: demand?.prestataire ? demand.prestataire : null,
      user: demand?.user ?? null,
      client: demand.client ? demand.client : null,
      free: demand.free,
      valide: demand.valide,
      refuser_par: demand.refuser_par,
      //data for client part
      prestataire_position: demand.prestataire_position,
      suivi: demand.suivi,
      proposed_provider: demand.proposed_provider,
      adresse: demand.adresse,
      lat: demand.lat,
      lng: demand.lng,
    };
  }
}
